<app-page-header-bar page-title="Relationships" [loading]="isLoadingRelationships()">
	<a routerLink="/interactions" mat-button>Interactions</a>

	<app-responsive-content second-row-content>
		<button (click)="addRelationship()" class="primary" mat-flat-button responsive-element="pinned">
			<mat-icon>add</mat-icon>
			<span>Add Relationship</span>
		</button>

		<div class="search-container" responsive-element="flex">
			<mat-form-field class="search" subscriptSizing="dynamic" appearance="outline">
				<input [(ngModel)]="searchValue" onfocus="this.select()" placeholder="Search" aria-label="Search relationships" [matAutocomplete]="autocomplete" matInput type="search" />
			</mat-form-field>
			<mat-autocomplete [class]="['custom-mat-panel', 'custom-scrollbar']" #autocomplete="matAutocomplete" [hideSingleSelectionIndicator]="true">
				@for (name of filteredNames(); track name) {
					<mat-option [value]="name">{{name}}</mat-option>
				}
			</mat-autocomplete>
		</div>

		<app-expand-collapse-menu responsive-element="menu"
			[show-expand]="showExpandAllGroupsButton()"
			[show-collapse]="showCollapseAllGroupsButton()"
			(expand-all)="collapseOrExpandAllGroups(true)"
			(collapse-all)="collapseOrExpandAllGroups(false)"
		/>
	</app-responsive-content>
</app-page-header-bar>

@if (hasRelationships()) {
	<p>
		Relationships are divided into groups based on the interaction goals you've set,
		and how long it's been since you last interacted with them.
	</p>
} @else if (groupedRelationships().length) {
	<p>
		Add relationships to see them grouped here based on your interaction goals
		and how long it's been since you last interacted with them.
	</p>
}

@if (isLoadingRelationships()) {
	<mat-spinner diameter="75" />
}
@else {
	@for (group of filteredGroupedRelationships(); track group.status) {
		@if (group.relationships.length) {
			@defer (hydrate on viewport) {
				<app-card-group
					group-of="relationships"
					[header]="group.status"
					[card-count]="group.relationships.length"
					[header-color]="group.statusColor"
					[is-card-in-group-highlighted]="group.status === highlightedCard().groupStatus"
				>
					@for (relationship of group.relationships; track relationship._id; let index = $index) {
						<app-card class="small-viewport-only"
							[relationship]="relationship"
							(edit-relationship)="editRelationship($event)"
							(delete-relationship)="deleteRelationship($event)"
							[scroll-to-and-highlight]="group.status === highlightedCard().groupStatus && index === highlightedCard().indexInGroup"
							always-show-left-text
							collapsible
						>
							<app-relationship-card-content [relationship]="relationship" />
						</app-card>
						<app-row class="large-viewport-only"
							[relationship]="relationship"
							[scroll-to-and-highlight]="group.status === highlightedCard().groupStatus && index === highlightedCard().indexInGroup"
							(edit-relationship)="editRelationship($event)"
							(delete-relationship)="deleteRelationship($event)"
						/>
					}
				</app-card-group>
			}
		}
	}
}
